import React from "react";
import { Check } from "lucide-react";

export const TAG_CHOICES = [
  "Procurement",
  "Supplier Management",
  "Approvals",
  "Finance",
  "Analytics",
  "Compliance",
  "Admin",
  "Other",
];

export function TagPicker({ value = [], onChange, testid = "tag-picker" }) {
  function toggle(tag) {
    const next = value.includes(tag)
      ? value.filter((t) => t !== tag)
      : [...value, tag];
    onChange?.(next);
  }
  return (
    <div className="flex flex-wrap gap-2" data-testid={testid}>
      {TAG_CHOICES.map((tag) => {
        const active = value.includes(tag);
        return (
          <button
            key={tag}
            type="button"
            data-testid={`${testid}-${tag.replace(/\s+/g, "-").toLowerCase()}`}
            onClick={() => toggle(tag)}
            className={[
              "inline-flex items-center gap-1.5 rounded-full border px-3 py-1 text-xs font-medium transition-colors",
              active
                ? "border-indigo-600 bg-indigo-600 text-white shadow-sm"
                : "border-slate-200 bg-white text-slate-600 hover:border-slate-300 hover:bg-slate-50",
            ].join(" ")}
          >
            {active && <Check size={12} strokeWidth={3} />}
            {tag}
          </button>
        );
      })}
    </div>
  );
}
